import { useRef, useState } from 'react'
import Tooltip from './Tooltip'

/**
 * The app's tooltip for a control that is NOT an `IconButton` — the top bar's glyphs, the
 * certificate studio's toolbar, a rich-text tool, the theme switch. Those are hand-built
 * buttons with their own shapes and pressed states, so they take the wiring rather than
 * the component:
 *
 *   const { hint, bubble } = useHint(label)
 *   <button aria-label={label} {...hint}>…</button>
 *   {bubble}
 *
 * `aria-label` stays the caller's job — the bubble is presentation, and nothing should
 * depend on it being rendered.
 */
export function useHint(label) {
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)

  return {
    /* Spread on the control. */
    hint: {
      ref: anchorRef,
      onMouseEnter: () => setOpen(true),
      onMouseLeave: () => setOpen(false),
      onFocus: () => setOpen(true),
      onBlur: () => setOpen(false),
    },
    /* Rendered beside it — it portals itself, so where it sits in the tree is free. */
    bubble: <Tooltip anchorRef={anchorRef} label={label} open={open} />,
  }
}
